(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {

        module.exports = definition();

    } else {

        RivalIQ.module('enums');
        RivalIQ.enums.likelyPromoted = definition();

    }

    function definition() {

        return {
            threshold: 0.5,
            filterTypes: {
                include: 'include',
                exclude: 'exclude',
                only: 'only'
            },
            values: {
                likelyPromoted: 'likelyPromoted',
                notLikelyPromoted: 'notLikelyPromoted'
            }
        };
    }
})();
